
import { rzTabs, rzIconFlightStart, rzIconFlightEnd, rzSimpleTable, rzPreloader, rzAirlineIcon, rzButton, rzIconReturn } from '@razlet/ui';
import { stringDateToDate } from '~/utils';
import timeSrc from '~/assets/img/time.png';

export default {
  name: 'tablo',
  components: {
    rzTabs,
    rzIconFlightStart,
    rzIconFlightEnd,
    rzSimpleTable,
    rzPreloader,
    rzAirlineIcon,
    rzIconReturn,
    rzButton,
  },
  filters: {
    time(value) {
      const date = stringDateToDate(value);
      const hours = String(date.getHours());
      const minutes = String(date.getMinutes());

      const displayHours = hours.length < 2 ? `0${hours}` : hours;
      const displayMinutes = minutes.length < 2 ? `0${minutes}` : minutes;
      return `${displayHours}:${displayMinutes}`;
    },
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      timeSrc,
      tabs: [
        {
          title: 'Прилет',
          value: 'arrival',
          icon: 'rz-icon-flight-end',
        },
        {
          title: 'Вылет',
          value: 'departure',
          icon: 'rz-icon-flight-start',
        },
      ],
      tableHead: [
        { name: 'Время' },
        { name: 'Направление' },
        { name: 'Авиакомпания' },
        { name: 'Статус' },
        { name: 'Примечание' },
      ],
      tableHeadMobile: [
        { name: 'Данные рейса' },
        { name: 'Время' },
      ],
      buttons: [
        { label: 'Вчера', value: 'yesterday' },
        { label: 'Сегодня', value: 'today' },
        { label: 'Завтра', value: 'tomorrow' },
      ],
      errorStatuses: ['cancel', 'delay'],
      direction: 'arrival',
      selectedDay: 'today',
    };
  },
  computed: {
    oppositeDirection() {
      return this.direction === 'departure' ? 'arrival' : 'departure';
    },
  },
  methods: {
    getTablo() {
      this.$emit('refresh', { day: this.selectedDay, direction: this.direction });
    },
    switchTab(tab) {
      this.direction = tab;
      this.getTablo();
    },
    changeDay(day) {
      this.selectedDay = day;
      this.getTablo();
    },
  },
};
